import * as React from "react";
import Container from "@amzn/awsui-components-react/polaris/container";
import Header from "@amzn/awsui-components-react/polaris/header";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import Select, { SelectProps } from "@amzn/awsui-components-react/polaris/select";
import { DrugOption } from "./ConsumptionGuardOverridePage";

interface Props {
  drugs: DrugOption[];
  selectedDrug: DrugOption | null;
  onChange: (drug: DrugOption | null) => void;
}

class DrugSelector extends React.Component<Props> {
  render() {
    const { drugs, selectedDrug, onChange } = this.props;

    const options: SelectProps.Option[] = drugs.map((d) => ({
      label: d.label,
      value: d.value,
    }));

    const selectedOption = selectedDrug
      ? { label: selectedDrug.label, value: selectedDrug.value }
      : null;

    return (
      <Container header={<Header variant="h3">Select Drug</Header>}>
        <FormField label="Drug">
          <Select
            selectedOption={selectedOption}
            onChange={({ detail }) => {
              const found = drugs.find((d) => d.value === detail.selectedOption.value) || null;
              onChange(found);
            }}
            options={options}
            placeholder="Select a drug..."
            filteringType="auto"
          />
        </FormField>
      </Container>
    );
  }
}

export default DrugSelector;
